import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation } from 'react-router-dom';
import './sidemenu.css';
import { useEffect, useRef, useState } from 'react';
import menuButton from '../../assets/icons/menu.png';
import toOpen from '../../assets/icons/toOpen.png';
import userIcon from '../../assets/icons/user.png'
import vehicleIcon from '../../assets/icons/vehicleActive.svg';
import vehicleInactive from '../../assets/icons/vehicleIact.svg';
import { Grid2, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import userInactive from '../../assets/icons/userInactive.png';
import fleetActive from '../../assets/icons/fleetAct.svg';
import fleetInactive from '../../assets/icons/fleetInact.svg';
import constants from '../../constant.js'
import dashboardIcon from '../../assets/icons/dashboardIcon.png';
import dashboardActive from '../../assets/icons/dashboardActive.png';
import settingsIcon from '../../assets/icons/settingscon.svg';
import settingsInactive from '../../assets/icons/settingsInactive.svg';
import customZoneAct from '../../assets/icons/customZoneAct.svg';
import customZoneInact from '../../assets/icons/customZoneInact.svg';
import geofenceAct from '../../assets/icons/geofenceAct.svg';
import geofence from '../../assets/icons/geofence.svg';
import homescreen from '../../assets/icons/homescreen.svg';
import homescreenAct from '../../assets/icons/homescreenAct.svg';
import analytics from '../../assets/icons/analytics.svg';
import analyticsAct from '../../assets/icons/analyticsAct.svg';
import corporate from '../../assets/icons/corporate.svg';
import corporateAct from '../../assets/icons/corporateAct.svg';
import surgePricing from '../../assets/icons/surgePricing.svg';
import surgePricingAct from '../../assets/icons/surgePricingAct.svg';
import customerDriver from '../../assets/icons/customerDriver.svg';
import customerDriverAct from '../../assets/icons/customerDriverAct.svg';
import driverDocs from '../../assets/icons/driverDocs.svg';
import driverDocsAct from '../../assets/icons/driverDocsAct.svg';
import mapView from '../../assets/icons/mapView.svg';
import mapViewAct from '../../assets/icons/mapViewAct.svg';
import promotions from '../../assets/icons/promotions.svg';
import promotionsAct from '../../assets/icons/promotionsAct.svg';

const Sidemenu = () => {
    // const [isOpen, setIsOpen] = useState(true);

    // const handleToggle = () => {
    //     setIsOpen(!isOpen);
    // };
    const [isOpen, setIsOpen] = useState(() => {
        // Retrieve isOpen from local storage or default to true
        return JSON.parse(localStorage.getItem('sidebarIsOpen')) ?? true;
    });

    const handleToggle = () => {
        setIsOpen((prevState) => {
            const newState = !prevState;
            localStorage.setItem('sidebarIsOpen', JSON.stringify(newState));
            return newState;
        });
    };
    
    const location = useLocation();
    const sidebarRef = useRef(null);
    useEffect(() => {
        const savedScrollPosition = sessionStorage.getItem('sidebarScrollPosition');
        if (sidebarRef.current && savedScrollPosition) {
            sidebarRef.current.scrollTop = parseInt(savedScrollPosition, 10);
        }
    }, []);

    // Save scroll position whenever it changes
    const handleScroll = () => {
        if (sidebarRef.current) {
            sessionStorage.setItem('sidebarScrollPosition', sidebarRef.current.scrollTop);
        }
    };

    const isActive = (path) => location.pathname === path;

    // Retrieve allowed tabs from local storage
    const allowedTabs = JSON.parse(localStorage.getItem('clientRoleTabs')) || [1, 2, 3, 4, 5, 6];
    // console.log("===allowedTabs===", allowedTabs);

    const SidebarTabs = constants.SidebarTabs;

    // Helper function to check if a tab should be displayed
    const hasPermission = (tabId) => allowedTabs.includes(tabId);

    const rideTypes = [
        { label: 'Ongoing Rides', path: '/rides/ongoing' },
        { label: 'Completed Rides', path: '/rides/completed' },
        { label: 'Cancelled Rides', path: '/rides/cancelled' },
        { label: 'Missed Rides', path: '/rides/timeout' },
    ];
      
    return (
        <Sidebar onScroll={handleScroll} ref={sidebarRef} collapsed={!isOpen} className="custom-sidebar">
            <div
                onClick={handleToggle}
                style={{ cursor: 'pointer', padding: '10px', textAlign: 'right',position: 'sticky',top: 0,backgroundColor: '#fff',zIndex: 10 }}
            >
                {!isOpen && (
                    <img src={toOpen} alt="menu icon" width="38px" height="38px" style={{marginRight:'12px'}} />
                )}
                
                {isOpen && (
                    <img src={menuButton} alt="menu icon" width="36px" height="36px" />
                )}
            </div>

            <Typography sx={{marginLeft: isOpen ? '6%' : '24%', color:'#D1D5DB', backgroundColor:'#fff'}}>Menu</Typography>
            <Menu>

                <Grid2 sx={{backgroundColor: isActive('/mainDashboard') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    <SubMenu
                        label="Dashboard"
                        defaultOpen="true"
                        icon = {
                            (isActive('/mainDashboard'))
                                ? <img src={dashboardActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                : <img src={dashboardIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                        }
                        component={<Link to="/mainDashboard" />}
                        style={{
                            paddingLeft:'8px',
                            // margin: '0 10px',
                            borderRadius: '8px',
                            // backgroundColor: isOpen ? '#0065FF' : '#fff',
                            backgroundColor: isActive('/mainDashboard') ? '#F3F8FF' : '#fff',
                            color: isActive('/mainDashboard') ? '#1A1E25' : '#83888E',
                            transition: 'all 0.3s ease',
                            // border: isOpen ? '1px solid #E6F0FF' : 'none'
                        }}
                    >
                    </SubMenu>
                </Grid2>
                
                {/* Rides SubMenu */}
                {hasPermission(SidebarTabs.RIDES) && (
                    <Grid2
                        sx={{
                            backgroundColor: (rideTypes.some((ride) => isActive(ride.path)) && isOpen) ? '#F3F8FF' : '#fff',
                            padding: '8px',
                            borderRadius: '8px',
                            margin: '4px',
                        }}
                    >
                        <SubMenu
                            label="Rides"
                            defaultOpen="true"
                            icon={
                                rideTypes.some((ride) => isActive(ride.path)) ? (
                                    <img
                                        src={vehicleIcon}
                                        width="36px"
                                        height="36px"
                                        style={{ paddingLeft: !isOpen ? '4px' : '0px' }}
                                    />
                                ) : (
                                    <img
                                        src={vehicleInactive}
                                        width="36px"
                                        height="36px"
                                        style={{ paddingLeft: !isOpen ? '4px' : '0px' }}
                                    />
                                )
                            }
                            style={{
                                paddingLeft: '8px',
                                borderRadius: '8px',
                                backgroundColor: rideTypes.some((ride) => isActive(ride.path)) ? '#F3F8FF' : '#fff',
                                color: rideTypes.some((ride) => isActive(ride.path)) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                {rideTypes.map((ride, index) => (
                                    <Grid2
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '4px',
                                            backgroundColor: isActive(ride.path) ? '#F3F8FF' : '#fff',
                                            color: isActive(ride.path) ? '#0065FF' : '#83888E',
                                            borderRadius: '8px',
                                        }}
                                    >
                                        <FiberManualRecordIcon
                                            sx={{
                                                color: isActive(ride.path) ? '#0065FF' : '#83888E',
                                                marginRight: '8px',
                                                width: '16px',
                                            }}
                                        />
                                        <MenuItem
                                            className="subItems"
                                            component={<Link to={ride.path} />}
                                            style={{
                                                paddingLeft: '20px',
                                                backgroundColor: isActive(ride.path) ? '#F3F8FF' : '#fff',
                                                color: isActive(ride.path) ? '#0065FF' : '#83888E',
                                                borderRadius: isActive(ride.path) ? '8px' : '0',
                                            }}
                                        >
                                            {ride.label}
                                        </MenuItem>
                                    </Grid2>
                                ))}
                            </Grid2>
                        </SubMenu>
                    </Grid2>
                )}

<Grid2 sx={{backgroundColor: isActive('/mapView') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {/* {hasPermission(SidebarTabs.GEOFENCE) && ( */}
                        <SubMenu
                            label="Map View"
                            defaultOpen="true"
                            icon = {
                                (isActive('/mapView'))
                                    ? <img src={mapViewAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={mapView} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/mapView" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/mapView') ? '#F3F8FF' : '#fff',
                                color: isActive('/mapView') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                            >
                        </SubMenu>
                    {/* )} */}
                </Grid2>

                {/* Manual dispatch will come here */}
                <Grid2 sx={{backgroundColor: isActive('/dispatcher') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    <SubMenu
                        label="Manual Dispatcher"
                        defaultOpen="true"
                        icon = {
                            (isActive('/dispatcher'))
                                ? <img src={userIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                : <img src={userInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                        }
                        component={<Link to="/dispatcher" />}
                        style={{
                            paddingLeft:'8px',
                            // margin: '0 10px',
                            borderRadius: '8px',
                            // backgroundColor: isOpen ? '#0065FF' : '#fff',
                            backgroundColor: isActive('/dispatcher') ? '#F3F8FF' : '#fff',
                            color: isActive('/dispatcher') ? '#1A1E25' : '#83888E',
                            transition: 'all 0.3s ease',
                            // border: isOpen ? '1px solid #E6F0FF' : 'none'
                        }}
                    >
                    </SubMenu>
                </Grid2>

                {hasPermission(SidebarTabs.USER) && (
                    <Grid2 sx={{backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                        <SubMenu
                            label="Users"
                            defaultOpen="true"
                            icon = {
                                (isActive('/') || isActive('/rider-details') || isActive('/driver-details'))
                                    ? <img src={customerDriverAct} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                    : <img src={customerDriver} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                            }
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details')) ? '#F3F8FF' : '#fff',
                                color: isActive('/') || isActive('/rider-details') || isActive('/driver-details') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: '1px solid #E6F0FF'
                            }}
                        >
                            <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                                <Grid2 sx={{
                                    display: 'flex', alignItems:'center',
                                    backgroundColor: (isActive('/') || isActive('/rider-details')) && isOpen ? '#fff' : '#fff',
                                    padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                                }}>
                                    <FiberManualRecordIcon 
                                            sx={{ 
                                                color: isActive('/rider-details') ? '#0065FF' : '#83888E', 
                                                marginRight: '8px',
                                                width:'16px'
                                            }} 
                                        />
                                    <MenuItem className='subItems' component={<Link to="/rider-details" />}
                                        style={{
                                            backgroundColor: isActive('/rider-details') ? '#F3F8FF' : '#fff',
                                            color: isActive('/rider-details') ? '#0065FF' : '#83888E',
                                            // border: isActive('/rider-details') ? '1px solid #96C0FF':'none',
                                            borderRadius: isActive('/rider-details') ? '8px':'0',
                                            // marginLeft: isActive('/rider-details') ? '0' : '4%',
                                            paddingLeft: '20px',
                                            // marginLeft: isOpen ? '16px' : '0px'
                                        }}
                                    >
                                        Customer
                                    </MenuItem>
                                </Grid2>

                                <Grid2 sx={{
                                    display: 'flex', alignItems:'center',
                                    backgroundColor: (isActive('/') || isActive('/rider-details') || isActive('/driver-details')) && isOpen ? '#fff' : '#fff',
                                    padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                                }}>
                                    <FiberManualRecordIcon 
                                        sx={{ color: (isActive('/') || isActive('/driver-details')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                    <MenuItem className='subItems' component={<Link to="/" />}
                                        style={{
                                            backgroundColor: (isActive('/') || isActive('/driver-details')) ? '#F3F8FF' : '#fff', 
                                            color: (isActive('/') || isActive('/driver-details')) ? '#0065FF' : '#83888E',
                                            // border: isActive('/') ? '1px solid #96C0FF':'none',
                                            borderRadius: (isActive('/') || isActive('/driver-details')) ? '8px':'0', paddingLeft:'20px',
                                            // marginLeft: isOpen ? '16px' : '0px', margin:'8px 0px 8px 40px'
                                        }}>
                                        
                                        Driver
                                    </MenuItem>
                                </Grid2>    
                            </Grid2>
                            
                        </SubMenu>
                    </Grid2>
                )}

                <Grid2 sx={{backgroundColor: isActive('/driver-documents') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {hasPermission(SidebarTabs.DRIVER_DOCUMENTS) && (
                        <SubMenu
                            label="Driver Documents"
                            defaultOpen="true"
                            icon = {
                                (isActive('/driver-documents'))
                                    ? <img src={driverDocsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={driverDocs} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/driver-documents" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/driver-documents') ? '#F3F8FF' : '#fff',
                                color: isActive('/driver-documents') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    )}
                </Grid2>

                <Grid2 sx={{backgroundColor: (isActive('/promotions')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {/* {hasPermission(SidebarTabs.ANALYTICS) && ( */}
                        <SubMenu
                            label="Promotions"
                            defaultOpen="true"
                            icon = {
                                (isActive('/promotions'))
                                    ? <img src={promotionsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={promotions} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/promotions" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/promotions')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/promotions')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    {/* )} */}
                </Grid2>

                <Grid2 sx={{backgroundColor: isActive('/vehicles') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {hasPermission(SidebarTabs.VEHICLE) && (
                        <SubMenu
                            label="Vehicle Type"
                            defaultOpen="true"
                            icon = {
                                (isActive('/vehicle'))
                                    ? <img src={vehicleIcon} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={vehicleInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/vehicle" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/vehicle') ? '#F3F8FF' : '#fff',
                                color: isActive('/vehicle') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    )}
                </Grid2>

                <Grid2 sx={{backgroundColor: isActive('/surge-pricing') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {/* {hasPermission(SidebarTabs.SURGEPRICING) && ( */}
                        <SubMenu
                            label="Surge Pricing"
                            defaultOpen="true"
                            icon = {
                                (isActive('/surge-pricing'))
                                    ? <img src={surgePricingAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={surgePricing} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/surge-pricing" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/surge-pricing') ? '#F3F8FF' : '#fff',
                                color: isActive('/surge-pricing') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    {/* )} */}
                </Grid2>

                <Grid2 sx={{backgroundColor: isActive('/fleets') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {hasPermission(SidebarTabs.FLEETS) && (
                        <SubMenu
                            label="Fleets"
                            defaultOpen="true"
                            icon = {
                                (isActive('/fleets'))
                                    ? <img src={fleetActive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={fleetInactive} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/fleets" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/fleets') ? '#F3F8FF' : '#fff',
                                color: isActive('/fleets') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                        >
                        </SubMenu>
                    )}
                </Grid2>

                <Grid2 sx={{backgroundColor: isActive('/corporate') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {hasPermission(SidebarTabs.CORPORATE) && (
                        <SubMenu
                            label="Corporate"
                            defaultOpen="true"
                            icon = {
                                (isActive('/corporate'))
                                    ? <img src={corporateAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={corporate} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/corporate" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/corporate') ? '#F3F8FF' : '#fff',
                                color: isActive('/corporate') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    )}
                </Grid2>

                <Grid2 sx={{backgroundColor: isActive('/geofence') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {/* {hasPermission(SidebarTabs.GEOFENCE) && ( */}
                        <SubMenu
                            label="Geofence"
                            defaultOpen="true"
                            icon = {
                                (isActive('/geofence'))
                                    ? <img src={geofenceAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={geofence} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/geofence" />}
                            style={{
                                paddingLeft:'8px',
                                borderRadius: '8px',
                                backgroundColor: isActive('/geofence') ? '#F3F8FF' : '#fff',
                                color: isActive('/geofence') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                            }}
                            >
                        </SubMenu>
                    {/* )} */}
                </Grid2>

                <Grid2 sx={{backgroundColor: isActive('/custom-zone') ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {/* {hasPermission(SidebarTabs.SURGEPRICING) && ( */}
                        <SubMenu
                            label="Custom Zone"
                            defaultOpen="true"
                            icon = {
                                (isActive('/custom-zone'))
                                    ? <img src={customZoneAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={customZoneInact} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/custom-zone" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: isActive('/custom-zone') ? '#F3F8FF' : '#fff',
                                color: isActive('/custom-zone') ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                        >
                        </SubMenu>
                    {/* )} */}
                </Grid2>

                <Grid2 sx={{backgroundColor: (isActive('/homescreen-settings') || isActive('/homeScreen-details')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {hasPermission(SidebarTabs.HOMESCREEN) && (
                        <SubMenu
                            label="Dynamic HomeScreen"
                            defaultOpen="true"
                            icon = {
                                (isActive('/homescreen-settings') || isActive('/homeScreen-details'))
                                    ? <img src={homescreenAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={homescreen} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/homescreen-settings" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/homescreen-settings') || isActive('/homeScreen-details')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/homescreen-settings')|| isActive('/homeScreen-details')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    )}
                </Grid2>

                <Grid2 sx={{backgroundColor: (isActive('/analytics')) ? '#F3F8FF' : '#fff', padding:'8px', borderRadius:'8px', margin:'4px'}}>
                    {hasPermission(SidebarTabs.ANALYTICS) && (
                        <SubMenu
                            label="Analytics"
                            defaultOpen="true"
                            icon = {
                                (isActive('/analytics'))
                                    ? <img src={analyticsAct} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                                    : <img src={analytics} width="36px" height="36px"  style={{ paddingLeft: !isOpen ? '4px' : '0px'}}/>
                            }
                            component={<Link to="/analytics" />}
                            style={{
                                paddingLeft:'8px',
                                // margin: '0 10px',
                                borderRadius: '8px',
                                // backgroundColor: isOpen ? '#0065FF' : '#fff',
                                backgroundColor: (isActive('/analytics')) ? '#F3F8FF' : '#fff',
                                color: (isActive('/analytics')) ? '#1A1E25' : '#83888E',
                                transition: 'all 0.3s ease',
                                // border: isOpen ? '1px solid #E6F0FF' : 'none'
                            }}
                            >
                        </SubMenu>
                    )}
                </Grid2>

                <Grid2 sx={{backgroundColor: (isActive('/settings/schedule-ride') || isActive('/manager_settings')) && isOpen ? '#F3F8FF' : '#fff', padding: '8px', borderRadius:'8px', margin:'4px'}}>

                    <SubMenu
                        label="Settings"
                        defaultOpen="true"
                        icon = {
                            (isActive('/settings/schedule-ride') || isActive('/manager_settings') || (isActive('/general_settings')) || (isActive('/city_settings')))
                                ? <img src={settingsIcon} width="36px" height="36px" style={{ paddingLeft: !isOpen ? '4px' : '0px'}} />
                                : <img src={settingsInactive} width="36px" height="36px" style={{paddingLeft: !isOpen ? '4px' : '0px'}} />
                        }
                        style={{
                            paddingLeft:'8px',
                            borderRadius: '8px',
                            backgroundColor: (isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/general_settings') || isActive('/city_settings')) ? '#F3F8FF' : '#fff',
                            color: (isActive('/settings/schedule-ride') || isActive('/manager_settings') || isActive('/general_settings')) ? '#1A1E25' : '#83888E',
                            transition: 'all 0.3s ease',
                        }}
                    >
                        <Grid2 item sx={{backgroundColor:'#fff', padding:'4%', paddingTop:'1%'}}>
                            <Grid2 sx={{
                                display: 'flex', alignItems:'center',
                                backgroundColor: (isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/general_settings') || isActive('/city_settings')) && isOpen ? '#fff' : '#fff',
                                padding: '12px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                            }}>
                                <FiberManualRecordIcon 
                                        sx={{ 
                                            color: isActive('/general_settings') ? '#0065FF' : '#83888E', 
                                            marginRight: '8px',
                                            width:'16px'
                                        }} 
                                    />
                                <MenuItem className='subItems' component={<Link to="/general_settings" />}
                                    style={{
                                        backgroundColor: isActive('/general_settings') ? '#F3F8FF' : '#fff',
                                        color: isActive('/general_settings') ? '#0065FF' : '#83888E',
                                        borderRadius: isActive('/general_settings') ? '8px':'0',
                                        paddingLeft: '20px',
                                    }}
                                >
                                    General Settings
                                </MenuItem>
                            </Grid2>

                            <Grid2 sx={{
                                display: 'flex', alignItems:'center',
                                backgroundColor: (isActive('/manager_settings') || isActive('/settings/schedule-ride') || isActive('/general_settings') || isActive('/city_settings')) && isOpen ? '#fff' : '#fff',
                                padding: '2px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                            }}>
                                <FiberManualRecordIcon 
                                        sx={{ 
                                            color: isActive('/city_settings') ? '#0065FF' : '#83888E', 
                                            marginRight: '8px',
                                            width:'16px'
                                        }} 
                                    />
                                <MenuItem className='subItems' component={<Link to="/city_settings" />}
                                    style={{
                                        backgroundColor: isActive('/city_settings') ? '#F3F8FF' : '#fff',
                                        color: isActive('/city_settings') ? '#0065FF' : '#83888E',
                                        borderRadius: isActive('/city_settings') ? '8px':'0',
                                        paddingLeft: '20px',
                                    }}
                                >
                                    City Settings
                                </MenuItem>
                            </Grid2>

                            <Grid2 sx={{
                                display: 'flex', alignItems:'center',
                                backgroundColor: (isActive('/settings/schedule-ride') || isActive('/manager_settings')) && isOpen ? '#fff' : '#fff',
                                padding: '2px 0px 2px 10px', paddingRight:!isOpen ? '10px': '0px'
                            }}>
                                <FiberManualRecordIcon 
                                    sx={{ color: (isActive('/settings/schedule-ride')) ? '#0065FF' : '#83888E', marginRight: '8px', width:'16px'}} />

                                <MenuItem className='subItems' component={<Link to="/settings/schedule-ride" />}
                                    style={{
                                        backgroundColor: (isActive('/settings/schedule-ride')) ? '#F3F8FF' : '#fff', 
                                        color: (isActive('/settings/schedule-ride')) ? '#0065FF' : '#83888E',
                                        borderRadius: (isActive('/settings/schedule-ride')) ? '8px':'0', paddingLeft:'20px',
                                    }}>
                                    
                                    Schedule Ride Settings
                                </MenuItem>
                            </Grid2>
                    
                            <Grid2 sx={{
                                display: 'flex', alignItems:'center',
                                backgroundColor: (isActive('/manager_settings') || isActive('/settings/schedule-ride')) && isOpen ? '#fff' : '#fff',
                                padding: '2px 0px 4px 10px', paddingRight:!isOpen ? '10px': '0px'
                            }}>
                                <FiberManualRecordIcon 
                                        sx={{ 
                                            color: isActive('/manager_settings') ? '#0065FF' : '#83888E', 
                                            marginRight: '8px',
                                            width:'16px'
                                        }} 
                                    />
                                <MenuItem className='subItems' component={<Link to="/manager_settings" />}
                                    style={{
                                        backgroundColor: isActive('/manager_settings') ? '#F3F8FF' : '#fff',
                                        color: isActive('/manager_settings') ? '#0065FF' : '#83888E',
                                        borderRadius: isActive('/manager_settings') ? '8px':'0',
                                        paddingLeft: '20px',
                                    }}
                                >
                                    Manager Settings
                                </MenuItem>
                            </Grid2>
                        </Grid2>

                    </SubMenu>
                </Grid2>
                
            </Menu>
        </Sidebar>
    );
};

export default Sidemenu;
